import { render, staticRenderFns } from "./CardBrand.vue?vue&type=template&id=0480fa6d&"
import script from "./CardBrand.vue?vue&type=script&lang=ts&"
export * from "./CardBrand.vue?vue&type=script&lang=ts&"
import style0 from "./CardBrand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports